
import { CheckBoxViewModel } from './CheckBoxViewModel';
export class Question {
  public LID: number;
  public ContractNumber: string;
  public CategoryID: number;
  public Category: string;
  public QSubject: string;
  public QDesc: string;
  public AttachmentFilePath: string;
  public FileId: string;
  public QDate: string;
  public Email: string;
  public Name: string;
  public QuestionCategoryList: CheckBoxViewModel[];
  public FileName: string;
  public PrevReply: string;
  public Reply: string;
  public QuestionId: string;
  public FileBase64: string;
}



// WEBPACK FOOTER //
// ./src/app/models/Question.ts